import {uniqueId} from 'lodash'

const optionsCol = [
  {
    title: 'Nickname',
    property: 'client.nickName',
    defaultProperty: 'client removed',
    route: 'client.id',
    pointer: true,
    sort: true,
    fixed: true,
    section: 1
  },
  {
    property: 'projectManagers',
    fixed: true,
    pointer: true,
    list: [
      {
        id: true,
        name: 'All assigned',
        checked: false
      },
      {
        id: false,
        name: 'Not all assigned',
        checked: false
      }
    ],
    section: 1
  },
  {
    title: 'Proforma No.',
    property: 'number',
    openInvoice: true,
    pointer: true,
    fixed: true,
    section: 1
  },
  {
    title: 'Date Invoiced',
    property: 'issueDate',
    section: 1
  },
  {
    title: 'Total Invoiced, AED',
    icon: 'icon-info',
    info: 'totalInvoiced',
    property: 'totalInvoicedAed',
    section: 1
  },
  {
    lastInSection: true,
    nameSection: 'Service Categories',
    section: 1
  },
  {
    title: 'VAT, AED',
    property: 'vat',
    border: true,
    section: 2
  },
  {
    title: '3rd Party Fees, AED',
    property: 'totalServices.thirdSideTotal',
    serviceType: 1,
    border: true,
    section: 2
  },
  {
    title: 'Admin Fees, AED',
    property: 'totalServices.adminTotal',
    icon: 'icon-info',
    info: 'adminTotal',
    serviceType: 0,
    border: true,
    section: 2
  },
  {
    title: 'BB Services, AED',
    property: 'totalServices.bbTotal',
    icon: 'icon-info',
    info: 'bbTotal',
    serviceType: 2,
    border: true,
    section: 2
  },
  {
    title: 'Extra Profit, AED',
    property: 'totalServices.extraTotal',
    icon: 'icon-info',
    info: 'extraTotal',
    border: true,
    section: 2
  },
  {
    endSection: true,
    section: 2
  },
  {
    title: 'Date Received',
    property: 'paymentDate',
    section: 3
  },
  {
    title: 'Tax Invoice',
    property: 'taxInvoice',
    editable: true,
    type: 'checkbox',
    center: true,
    section: 3
  },
  {
    title: 'Tax Inv No.',
    property: 'taxInvoiceNumber',
    editable: true,
    type: 'input',
    section: 3
  },
  {
    title: 'Received , AED',
    property: 'received',
    icon: 'icon-info',
    info: 'totalReceived',
    comparison: 'totalInvoicedAed',
    section: 3
  },
  {
    lastInSection: true,
    nameSection: 'Applied Service Categories',
    section: 3
  },
  {
    title: 'Applied VAT, AED',
    property: 'currentVat',
    border: true,
    section: 4
  },
  {
    title: 'Applied 3rd Party Fees, AED',
    property: 'currentServices.thirdSide',
    border: true,
    wide: true,
    section: 4
  },
  {
    title: 'Applied Admin Fees, AED',
    property: 'currentServices.admin',
    border: true,
    wide: true,
    icon: 'icon-info',
    info: 'adminCurrentTotal',
    section: 4
  },
  {
    title: 'Applied BB Services, AED',
    property: 'currentServices.bb',
    border: true,
    wide: true,
    icon: 'icon-info',
    info: 'bbCurrentTotal',
    section: 4
  },
  {
    title: 'Business Consultant',
    property: 'businessConsultant',
    modified: 'businessConsultant',
    type: 'select',
    border: true,
    section: 4
  },
  {
    lastInSection: true,
    nameSection: 'BB Services',
    section: 4
  },
  {
    property: 'dynamic',
    hide: true,
    section: 5
  },
  {
    endSection: true,
    section: 5
  },
  {
    title: 'Extra Profit, AED',
    property: 'currentServices.extra',
    border: true,
    section: 6
  },
  {
    title: 'Extra Business Consultant',
    property: 'extraBusinessConsultant',
    modified: 'businessConsultant',
    type: 'select',
    border: true,
    section: 6
  },
  {
    lastInSection: true,
    nameSection: 'Extra Services',
    section: 6
  },
  {
    property: 'dynamicThirdSideService',
    hide: true,
    section: 7
  },
  {
    endSection: true,
    section: 7
  },
  {
    title: 'Status',
    property: 'status',
    comparison: 'totalInvoicedAed',
    list: [
      {
        id: 'not_paid',
        name: 'Not paid',
        checked: false
      },
      {
        id: 'overpaid',
        name: 'Overpaid',
        checked: false
      },
      {
        id: 'paid',
        name: 'Paid',
        checked: false
      },
      {
        id: 'underpaid',
        name: 'Underpaid',
        checked: false
      }
    ],
    section: 8
  },
  {
    title: 'Amount, AED',
    property: 'amount',
    comparison: 'totalInvoicedAed',
    section: 8
  },
  {
    class: 'write-off',
    button: 'Write off',
    section: 8
  }
]

const prefix = 'invoice_column_'
export const columns = optionsCol.map(item => {
  item.id = uniqueId(prefix)
  return item
})



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/invoicesTable.js